import { Ban, CheckCircle2, CirclePause, Sparkles } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { SurfaceTab } from "../api/types";

export type TabHint = {
  title: string;
  body: string;
};

export const TAB_ICONS: Record<SurfaceTab, LucideIcon> = {
  review: Sparkles,
  skipped: CirclePause,
  accepted: CheckCircle2,
  rejected: Ban,
};

/** Impact for marketers: what this status means for using the images. */
export const TAB_HINTS: Record<SurfaceTab, TabHint> = {
  review: {
    title: "Needs a yes or no",
    body: "Not usable in marketing until you Accept them.",
  },
  skipped: {
    title: "You postponed these",
    body: "Still not usable in marketing until you Accept or Reject them.",
  },
  accepted: {
    title: "Ready to use",
    body: "These can go into work files, page cards, and publish.",
  },
  rejected: {
    title: "Won’t be used",
    body: "These stay out of work files and marketing pages.",
  },
};

/** Empty-tab copy: what this means + what to do next. */
export const TAB_EMPTY_STATES: Record<SurfaceTab, TabHint> = {
  review: {
    title: "Nothing to review",
    body: "When new drafts arrive, Accept the ones you want for marketing, or Reject the ones you don’t.",
  },
  skipped: {
    title: "Nothing on hold",
    body: "Use Skip on a Review item when you’re not ready to decide. Come back here later to Accept or Reject.",
  },
  accepted: {
    title: "Nothing accepted yet",
    body: "Accept images from Review or Skip (with solution tags). Only accepted images can be used in marketing.",
  },
  rejected: {
    title: "Nothing rejected",
    body: "Reject images you don’t want for marketing. You can still Accept them later if you change your mind.",
  },
};
